import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { Icon } from 'Components/UI'

import {
  blueprintGlyph,
  dAppDevelopmentGlyph,
  dAppMaintenanceGlyph,
  dAppQualityGlyph,
  dAppReleaseGlyph,
  planGlyph,
} from 'Assets/_Legacy/BlockchainPage'

import { Container } from './styles'

function ImageBlock({ index }) {
  const glyph = useMemo(() => {
    switch (index) {
      case 0:
        return blueprintGlyph
      case 1:
        return planGlyph
      case 2:
        return dAppDevelopmentGlyph
      case 3:
        return dAppQualityGlyph
      case 4:
        return dAppReleaseGlyph
      case 5:
        return dAppMaintenanceGlyph
      default:
        return undefined
    }
  }, [index])

  return (
    <Container>
      <Icon glyph={glyph} height={[212, 212, 220, 295, 360]} width="90%" />
    </Container>
  )
}

ImageBlock.defaultProps = {}

ImageBlock.propTypes = {
  index: PropTypes.number.isRequired,
}

export default ImageBlock
